$(function() {
  console.log(123);
  // 初始化导航栏
  if($(".new-mega-menu-nav-active").length > 0) {
    $(".new-mega-menu-nav-active").each(function () {
      var targetnav = $(this).attr("targetnav");
      console.log(targetnav);
      $("#" + targetnav).css("display", "block");
    });
  }

  $(".new-mega-menu-sublink").hover(function() {
    console.log(567);
    var parentNav = $(this).parent();
    $(this).closest('.new-mega-menu__nav').find('.new-mega-menu-sublink').each(function() {
      if($(this).hasClass("new-mega-menu-nav-active")) {
        $(this).removeClass("new-mega-menu-nav-active");
      }
    });
    $(this).addClass("new-mega-menu-nav-active");
    $(this).closest('.new-mega-menu-left').next(".new-mega-menu-right").find(".new-mega-menu-content").each(function() {
      $(this).css("display", "none");
    });
    var currentNav = $(this).attr("targetnav");
    console.log(currentNav);
    $("#" + currentNav).css("display", "block");
  });


  $(".new-mega-menu-expand-and-collapse-button").click(function() {
    var content = $(this).next(".new-mega-menu-expand-and-collapse-content");
    if(content.is(":hidden")) {
      $(this).find("svg").css("transform", "rotate(90deg)");
    }else {
      $(this).find("svg").css("transform", "rotate(0deg)");
    }
    content.slideToggle();
  });
});